import Switch from '../../../components/Switch/Switch';
import styled from 'styled-components';
import SplineMobile from '../../../components/SplineMobile/SplineMobile';
const CallToAction = () => {
  return (
    <Container>
      <ContainerBox>
        <LeftDivision>
          {/* <img
            src="https://cdn.prod.website-files.com/5f030e7bdf54ce3c5daf3964/6630d2993b3e2c9852dee33a_Image%20(2).webp"
            alt=""
          /> */}
          <SplineMobile />
        </LeftDivision>
        <RightDivision>
          <div>
            <h4 className="manrope-bold ">
              Switch Between Student & Enterprise Support
            </h4>

            <div className="list">
              <div className="listInfo">
                <h6 className="manrope-semibold heading-color">
                  Tailored Support for Students & Businesses
                </h6>
                <SubHeading className="manrope-regular">
                  Whether you're a student seeking academic guidance or an
                  enterprise easily switch between tailored services to meet
                  your needs.
                </SubHeading>
              </div>
            </div>
            <center>
              <Switch />
            </center>
          </div>
        </RightDivision>
      </ContainerBox>
    </Container>
  );
};

export default CallToAction;

const SubHeading = styled.p`
  color: #aaaaaa;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const ContainerBox = styled.div`
  width: 100%;
  max-width: 1140px;
  padding: 2.25px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`;

const LeftDivision = styled.div`
  width: 40%;
  min-height: 40rem;
  img {
    border-radius: 0.5rem;
    width: 100%;
  }

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 20px;
  }
`;

const RightDivision = styled.div`
  width: 60%;
  padding-left: 2rem;
  display: flex;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
    padding-left: 0rem;
    padding: 0 1.5rem;
  }

  h4 {
    font-size: 1.7rem;
  }
  .list {
    margin: 2.5rem 0rem;
    display: flex;
  }
  .listIconContainer {
    margin-top: 0.65rem;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    span {
      svg {
        height: 0.85rem;
        width: 0.85rem;
      }
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      padding: 0;
      padding: 0.25rem;
      border: 2px solid black;
    }
  }
  .listInfo {
    padding-left: 1rem;
    display: flex;
    flex-direction: column;
    h6 {
      font-size: 1.6rem;
    }
    p {
      padding-right: 2.5rem;
      font-size: 0.9rem;
    }
  }
`;
